;
$(document).ready(function() {
    $(".accordion > dd > a").click(function(e) {
        e.preventDefault();
        var $this = $(this); // a
        var $accordionGroup = $this.parent(); // dd
        var $accordion = $accordionGroup.parent(); // dl

        var isOpen = $this.hasClass('active');

        // Figure out if clicking closes the group
        var closeGroup = $accordion.attr('data-accordion-close-others') === 'true';
        if ( closeGroup ) {
            $('dd > a', $accordion).removeClass('active');
            $('dd > div', $accordion).css('display', '');
        }

        if ( !isOpen ) {
            $('> a', $accordionGroup).addClass('active');
            $('> div', $accordionGroup).css('display', 'block');
        }
    });
});